<div
  cdkDrag
  class="deal-details-container-drag resize-able deal-details-container"
  (cdkDragStarted)="dragStart()"
  (cdkDragEnded)="dragEnd()"
  cdkDragBoundary=".exotics-main"
  [ngStyle]="{ 'top.px': windowTop, 'left.px': windowLeft }"
>
  <div class="menu-bar" cdkDragHandle (mousedown)="updateZIndex()">
    <div class="deal-details-container-content__menu-bar__title">
      RFQ Timeline
    </div>
    <button class="button-close" (click)="closeContainer()"></button>
  </div>

  @if (status === 'Loaded') {
    <div class="graph-content">
      <div class="graph-content__graph-container">
        <div #scatterPlotContainer class="scatter-plot-container"></div>
      </div>
      <div class="graph-content__deal-details-key-info">
        <span
          class="graph-content__deal-details-key-info__legend graph-content__deal-details-key-info__empty-circle"
        ></span>
        <span>Offer</span> &nbsp;

        <span
          class="graph-content__deal-details-key-info__legend graph-content__deal-details-key-info__filled-circle"
        ></span>
        <span>Bid</span>
      </div>
    </div>
  } @else if (status === 'Loading') {
    <div class="deal-details-container__loading">
      <loading-spinner [size]="'40px'"></loading-spinner>
    </div>
  } @else if (status === 'Error') {
    <span>Failed to load data</span>
  }
</div>
